// src/features/manual/components/StaffLabel.tsx

import React from 'react';
import { useTranslate } from 'react-admin';
import { Typography, type SxProps, type Theme } from '@mui/material';
import { LockOutlined as StaffIcon } from '@mui/icons-material';

/**
 * «Solo personal de Roommatik»: the lock and the uppercase label that mark staff text, on the staff
 * box of a chapter and on a staff search result alike.
 */
export const StaffLabel: React.FC<{ sx?: SxProps<Theme> }> = ({ sx }) => {
  const translate = useTranslate();
  return (
    <Typography
      component="p"
      data-staff-label
      sx={[
        (theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          m: 0,
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          color: theme.custom.text.brandStrong,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <StaffIcon sx={{ fontSize: 16 }} aria-hidden />
      {translate('manual.staff.label')}
    </Typography>
  );
};

export default StaffLabel;
